import React from 'react';
import experience from '../constants/experience';
import ExperienceBox from './ExperienceBox';

const Experience = () => {
  return (
    <div id='experience_section'>
      <h1 className='projectHeading'>Experience</h1>
      <div className='timeline-container'>
        {experience.map(item => (
          <ExperienceBox
            key={item.id}
            logo={item.logo}
            company={item.company}
            role={item.role}
            date={item.date}
            desc={item.desc}
          />
        ))}
      </div>
    </div>
  )
}

export default Experience;
